import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../../components/Header';
import Modal from '../../components/Modal';
import MultiSelectBusca from '../../components/MultiSelectBusca';
import api from '../../api';

const toast = (title) => Swal.fire({ toast: true, position: 'bottom-end', icon: 'success', title, timer: 2800, showConfirmButton: false });

export default function AtaPastas() {
  const [pastas, setPastas] = useState([]);
  const [perfis, setPerfis] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [form, setForm] = useState(null);
  const [mover, setMover] = useState(null);
  const [salvando, setSalvando] = useState(false);

  function carregar() {
    return api.get('/atas/pastas')
      .then(({ data }) => setPastas(data.pastas))
      .catch(err => Swal.fire('Erro', err.response?.data?.error || 'Não foi possível carregar as pastas.', 'error'))
      .finally(() => setCarregando(false));
  }
  useEffect(() => {
    carregar();
    api.get('/perfis').then(({ data }) => setPerfis(data.perfis)).catch(() => {});
  }, []);

  async function salvar() {
    if (!form.nome.trim()) return Swal.fire('Falta o nome', 'Dê um nome à pasta.', 'warning');
    setSalvando(true);
    const payload = { nome: form.nome.trim(), descricao: form.descricao.trim() || null, perfis: form.perfis };
    if (String(form.ordem).trim() !== '') payload.ordem = parseInt(form.ordem) || 0;
    try {
      if (form.id) await api.put(`/atas/pastas/${form.id}`, payload);
      else await api.post('/atas/pastas', payload);
      toast(form.id ? 'Pasta atualizada' : 'Pasta criada');
      setForm(null);
      carregar();
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Não foi possível salvar.', 'error');
    } finally { setSalvando(false); }
  }

  async function excluir(p) {
    if (p.qtd_atas > 0) return setMover({ pasta: p, destino: '' });
    const r = await Swal.fire({
      icon: 'warning', title: `Excluir "${p.nome}"?`, text: 'A pasta está vazia.',
      showCancelButton: true, confirmButtonText: 'Sim, excluir', cancelButtonText: 'Cancelar', confirmButtonColor: '#C62828',
    });
    if (!r.isConfirmed) return;
    try { await api.delete(`/atas/pastas/${p.id}`); toast('Pasta excluída'); carregar(); }
    catch (err) { Swal.fire('Erro', err.response?.data?.error || 'Não foi possível excluir.', 'error'); }
  }

  async function moverEExcluir() {
    if (!mover.destino) return Swal.fire('Escolha o destino', 'Selecione pra qual pasta as atas vão.', 'warning');
    setSalvando(true);
    try {
      const { data } = await api.delete(`/atas/pastas/${mover.pasta.id}?mover_para=${mover.destino}`);
      toast(`${data.movidas} ata(s) movida(s) e pasta excluída`);
      setMover(null);
      carregar();
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Não foi possível excluir.', 'error');
    } finally { setSalvando(false); }
  }

  const perfisOptions = perfis.map(p => ({ value: p.id, label: p.titulo }));

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 900 }}>
        <Link to="/atas" className="doc-voltar"><i className="bi bi-arrow-left"></i> Atas</Link>
        <div className="adm-topo">
          <div>
            <h1>Pastas de reunião</h1>
            <p>
              Cada pasta é um tipo de reunião, e a permissão fica <strong>na pasta</strong>: toda ata criada
              dentro dela já nasce restrita aos cargos liberados aqui.
            </p>
          </div>
          <button className="btn-centrao" onClick={() => setForm({ id: null, nome: '', descricao: '', ordem: '', perfis: [] })}>
            <i className="bi bi-plus-lg me-1"></i> Nova pasta
          </button>
        </div>

        {carregando ? <div>Carregando…</div> : (
          <div className="adm-tabela-wrap">
            <table className="adm-tabela">
              <thead><tr><th>Pasta</th><th className="adm-num">Atas</th><th>Quem enxerga</th><th></th></tr></thead>
              <tbody>
                {pastas.map(p => (
                  <tr key={p.id} className={p.perfis.length === 0 ? 'adm-linha-alerta' : ''}>
                    <td>
                      <strong>{p.nome}</strong>
                      {p.descricao && <div className="adm-sub">{p.descricao}</div>}
                    </td>
                    <td className="adm-num">{p.qtd_atas}</td>
                    <td>
                      {p.perfis.length
                        ? p.perfis.map(x => x.titulo).join(', ')
                        : <span className="adm-badge adm-badge--alerta">só RH e diretoria</span>}
                    </td>
                    <td>
                      <div className="adm-acoes">
                        <button className="adm-btn-icone" title="Editar"
                                onClick={() => setForm({ id: p.id, nome: p.nome, descricao: p.descricao || '', ordem: p.ordem ?? '', perfis: p.perfis.map(x => x.id) })}>
                          <i className="bi bi-pencil"></i>
                        </button>
                        <button className="adm-btn-icone adm-btn-icone--perigo" title="Excluir" onClick={() => excluir(p)}>
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {pastas.length === 0 && <tr><td colSpan={4} className="adm-vazio">Nenhuma pasta ainda.</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </main>

      <Modal
        aberto={!!form}
        titulo={form?.id ? 'Editar pasta' : 'Nova pasta'}
        largura={560}
        onFechar={() => setForm(null)}
        rodape={<>
          <button className="btn btn-outline-secondary" onClick={() => setForm(null)}>Cancelar</button>
          <button className="btn-centrao" disabled={salvando} onClick={salvar}>{salvando ? 'Salvando…' : 'Salvar pasta'}</button>
        </>}
      >
        {form && (
          <>
            <label className="doc-label">Nome *</label>
            <input className="doc-input" value={form.nome} maxLength={120} autoFocus
                   onChange={e => setForm(s => ({ ...s, nome: e.target.value }))} placeholder="Ex.: Reunião de Gerentes de Venda" />
            <label className="doc-label">Descrição</label>
            <input className="doc-input" value={form.descricao} maxLength={400}
                   onChange={e => setForm(s => ({ ...s, descricao: e.target.value }))} placeholder="Uma linha explicando a reunião" />
            <label className="doc-label">Quem enxerga esta pasta</label>
            <p className="doc-hint">
              Sem nenhum cargo, <strong>só RH e diretoria</strong> veem as atas daqui. Ata é registro de gestão:
              o padrão é fechado, pra não vazar por esquecimento.
            </p>
            <MultiSelectBusca options={perfisOptions} values={form.perfis}
                              onChange={v => setForm(s => ({ ...s, perfis: v }))} placeholder="Buscar cargo…" icon="bi-people" />
            <label className="doc-label">Ordem</label>
            <input className="doc-input" type="number" value={form.ordem} placeholder="Em branco = vai pro fim"
                   onChange={e => setForm(s => ({ ...s, ordem: e.target.value }))} />
          </>
        )}
      </Modal>

      <Modal
        aberto={!!mover}
        titulo="Excluir pasta com atas"
        onFechar={() => setMover(null)}
        rodape={<>
          <button className="btn btn-outline-secondary" onClick={() => setMover(null)}>Cancelar</button>
          <button className="btn btn-danger" disabled={salvando} onClick={moverEExcluir}>{salvando ? 'Movendo…' : 'Mover e excluir'}</button>
        </>}
      >
        {mover && (
          <>
            <p style={{ marginTop: 0 }}>
              <strong>{mover.pasta.nome}</strong> tem <strong>{mover.pasta.qtd_atas} ata(s)</strong>. Escolha pra onde elas vão:
            </p>
            <select className="doc-input" value={mover.destino} onChange={e => setMover(s => ({ ...s, destino: e.target.value }))}>
              <option value="">Escolha a pasta…</option>
              {pastas.filter(p => p.id !== mover.pasta.id).map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
            </select>
            <p className="doc-hint">Atenção: quem enxerga as atas passa a ser quem está liberado na pasta de destino.</p>
          </>
        )}
      </Modal>
    </>
  );
}
